import React from 'react';
import './App.css';
import MainContainer from './containers/MainContainer';

function App() {
  return (
    <div className="App">
      <MainContainer />
    </div>
  );
}

export default App;
